import { useMemo, useState, useEffect } from "react";
import { Info } from "@phosphor-icons/react";
import {
  DEFAULT_REFERRAL_SOURCE_OPTIONS,
  REFERRAL_SOURCE_OTHER,
  getCustomReferralSources,
  isKnownReferralSource,
} from "../../utils/referralSources";
import "./ReferralSourceField.css";

function ReferralSourceField({
  value,
  onChange,
  therapistProfile,
  selectClassName,
  showEmptyOption = true,
}) {
  const customSources = useMemo(
    () => getCustomReferralSources(therapistProfile),
    [therapistProfile]
  );

  const valueIsCustomNewEntry = useMemo(
    () => Boolean(value) && !isKnownReferralSource(value, therapistProfile),
    [value, therapistProfile]
  );

  const [otherMode, setOtherMode] = useState(valueIsCustomNewEntry);

  useEffect(() => {
    if (valueIsCustomNewEntry) {
      setOtherMode(true);
    }
  }, [valueIsCustomNewEntry]);

  const selectValue = useMemo(() => {
    if (otherMode) return REFERRAL_SOURCE_OTHER;
    if (!value) return "";
    if (value === "other") return REFERRAL_SOURCE_OTHER;
    return value;
  }, [otherMode, value]);

  const handleSelectChange = (e) => {
    const next = e.target.value;
    if (next === REFERRAL_SOURCE_OTHER) {
      setOtherMode(true);
      onChange("");
    } else {
      setOtherMode(false);
      onChange(next);
    }
  };

  const handleOtherInputChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className="referral-source-field">
      <select
        className={selectClassName}
        value={selectValue}
        onChange={handleSelectChange}
      >
        {showEmptyOption && <option value="">בחר אפשרות</option>}
        {DEFAULT_REFERRAL_SOURCE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
        {customSources.length > 0 && (
          <optgroup label="המקורות שלי">
            {customSources.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </optgroup>
        )}
        <option value={REFERRAL_SOURCE_OTHER}>אחר...</option>
      </select>

      {otherMode && (
        <div className="referral-source-other">
          <input
            type="text"
            value={value === "other" ? "" : value || ""}
            onChange={handleOtherInputChange}
            placeholder="הקלד מקור הפניה חדש"
            maxLength={60}
          />
          <span className="referral-source-hint">
            <Info size={14} weight="fill" />
            הערך שתקליד יישמר אוטומטית לרשימת המקורות שלך לשימוש בעתיד.
          </span>
        </div>
      )}
    </div>
  );
}

export default ReferralSourceField;
